"use strict"
import './components/config'
import './components/header'
import './components/data-src'
import './components/nav'
import './components/slider'
import './components/tooltip'
import './components/count-up'
import './components/dropdown'
import './components/ck-editor'
import './components/dashboard'
import './components/map'
import './components/faq-submit'
import './components/form-submit'
import './components/dynamic-fields'
import './components/tabs'
import './components/gallery'
import './components/youtube'
import './components/animations'
import './components/cookies'
import './components/popup'
import './components/dropzone-actions'
import './components/parallax'